import {
    customCommand,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeReadyStatusNotReady,
} from "../../../api";
import BigTpl from "../BigTpl";

export default class BigTemplateAPIList extends BigTpl {
    constructor(props) {
        super(props);

    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        let MTG_SDKContext = await this.initSDKContext()
        console.log(MTG_SDKContext)

        if (MTG_SDKContext && MTG_SDKContext.campaignList && MTG_SDKContext.campaignList.length > 0) {
            console.log('demo 页 load ready', {MTG_SDKContext})
            VideoBridgeReadyStatusHasReady()
            if (window.MTG_RENDER) {
                window.MTG_RENDER(MTG_SDKContext)
            } else {
                console.warn('全局 window.MTG_RENDER 未注册, 请检查')
            }
        } else {
            VideoBridgeReadyStatusNotReady()
            console.error('API list 页 load 失败, campaignList 为空', {MTG_SDKContext})
        }
    }

    show(res) {
        super.show(res);
    }

    customCommand({fnName, params}) {
        return customCommand({fnName, params})
    }

}